import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalAddClient from "./ModalAddClient";
import _ from "lodash";
import { Card, Row, Col, Button, Input, Avatar, Tooltip, Tag, Space, Switch } from "antd";
import { ProTable } from "@ant-design/pro-components";
import { faBinoculars, faFolderOpen, faPlus } from "@fortawesome/free-solid-svg-icons";
import ModalQuickViewClient from "./ModalQuickViewClient";

function Clients(props) {
  const navigate = useNavigate();
  const table_columns = [
    {
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      render: (text, row) => <Link to={"/client-details/" + row.client_tag}>{text}</Link>,
    },
    {
      title: "Primary Contact",
      dataIndex: "primary_contact",
      key: "primary_contact",
      render: (text, row) => {
        if (text === "null") return "-";
        return text ? text : "-";
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Partner",
      dataIndex: "partner",
      key: "partner",
      render: (text, row) => {
        if (text === "null") return "";
        if (row.partner_image !== "dui2.png")
          return (
            <Tooltip title={text}>
              <Avatar
                style={{
                  backgroundColor: "#00a2ae",
                  verticalAlign: "middle",
                }}
                size="large"
                gap={1}
                src={<img src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + row.partner_image} alt="avatar" />}
              />
            </Tooltip>
          );
        return (
          <Tooltip title={text}>
            <Avatar
              style={{
                backgroundColor: "#00a2ae",
                verticalAlign: "middle",
              }}
              size="large"
              gap={4}
            >
              {_.words(text)
                .map((m) => m[0])
                .join(" ")}
            </Avatar>
          </Tooltip>
        );
      },
    },
    {
      title: "Manager",
      dataIndex: "manager",
      key: "manager",
      render: (text, row) => {
        if (text === "null") return "";
        if (row.manager_image !== "dui2.png")
          return (
            <Tooltip title={text}>
              <Avatar
                style={{
                  backgroundColor: "#00a2ae",
                  verticalAlign: "middle",
                }}
                size="large"
                gap={4}
                src={<img src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + row.manager_image} alt="avatar" />}
              />
            </Tooltip>
          );
        return (
          <Tooltip title={text}>
            <Avatar
              style={{
                backgroundColor: "#00a2ae",
                verticalAlign: "middle",
              }}
              size="large"
              gap={4}
            >
              {_.words(text)
                .map((m) => m[0])
                .join(" ")}
            </Avatar>
          </Tooltip>
        );
      },
    },
    {
      title: "Categories",
      dataIndex: "client_categories",
      key: "client_categories",
      render: (text, row) => {
        if (text === "null") return "";
        return (
          <Space size={[0, 8]} wrap>
            {_.split(text, "| ").map((m, index) => (
              <Tag key={"tag-key-" + row.client_id + "-" + index}>{m}</Tag>
            ))}
          </Space>
        );
      },
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "client_id",
      key: "client_id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="default"
            onClick={() => {
              setQuickViewProps({ open: true, client_id: row.client_id });
              // GetClient(row.client_id);
            }}
          >
            <FontAwesomeIcon icon={faBinoculars} size="1x" className="mr-1" />
            Quick View
          </Button>
          <Link to={"/client-details/" + row.client_tag}>
            <Button type="primary" size="small">
              <FontAwesomeIcon icon={faFolderOpen} size="1x" className="mr-1" />
              Detail View
            </Button>
          </Link>
        </Space>
      ),
    },
  ];
  const [tableData, setTableData] = useState([]);
  const [tableSearch, setTableSearch] = useState(null);
  const [showDeactivated, setShowDeactivated] = useState(false);

  const [quickViewProps, setQuickViewProps] = useState({ open: false, client_id: null, refresh: false });
  const [addModalProps, setAddModalProps] = useState({ open: false, refresh: false });

  const GetClients = async (params = { current: 1, pageSize: 20, search: null }, sort = {}, filter = {}) => {
    let response = await props.AxiosRequest("/api/clients/get/ssp", { params, sort, filter, tableSearch, show_deactivated: showDeactivated });
    setTableData(
      response.data.data.map((m) => {
        return { ...m, key: m.id };
      }),
    );
    return response.data;
  };

  useEffect(() => {
    if (quickViewProps.refresh) {
      setQuickViewProps({ ...quickViewProps, refresh: false });
      GetClients({ current: 1, pageSize: 20, search: tableSearch });
    }
    // eslint-disable-next-line
  }, [quickViewProps?.refresh]);

  useEffect(() => {
    if (addModalProps.refresh) {
      setAddModalProps({ ...addModalProps, refresh: false });
      if (addModalProps?.tag) navigate("/client-details/" + addModalProps.tag);
    }
    // eslint-disable-next-line
  }, [addModalProps?.refresh]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Clients</h1>
        </div>
        <Row>
          <Card
            // size="small"
            title="Client List"
            extra={
              <Button
                type="primary"
                onClick={() => {
                  setAddModalProps({ open: true });
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-1" /> Add New Client
              </Button>
            }
            style={{
              width: "100%",
            }}
            bodyStyle={{ paddingLeft: "0px", paddingRight: "0px", paddingTop: "2px" }}
          >
            <Row>
              <Col span={24}>
                <ProTable
                  className="pro-table-striped"
                  highlightOnHover
                  pagination={{
                    // total: tableData.length,
                    hideOnSinglePage: true,
                    showTotal: (total, range) => {
                      return `Showing ${range[0]} to ${range[1]} of ${total}` + (tableSearch?.length ? ` (filtered)` : ``) + ` entries`;
                    },
                  }}
                  // pagination
                  paginationComponentOptions={{
                    selectAllRowsItem: true,
                  }}
                  pointerOnHover
                  responsive
                  striped
                  subHeaderAlign="right"
                  subHeaderWrap
                  columns={table_columns}
                  search={false}
                  toolbar={{
                    title: "  ",
                    search: (
                      <Input
                        placeholder="Search..."
                        value={tableSearch}
                        allowClear
                        onChange={(change) => {
                          setTableSearch(change.target.value);
                        }}
                      />
                    ),
                  }}
                  options={false}
                  dataSource={tableData}
                  params={{ search: tableSearch, show_deactivated: showDeactivated }}
                  request={GetClients}
                  debounceTime={500}
                />
              </Col>
              <Col span={23} className="text-right">
                <label className="col-form-label-sm w-100">Show Deactivated Customers?</label>
                <Switch
                  value={showDeactivated}
                  onChange={(e) => {
                    setShowDeactivated(e);
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Row>
      </div>
      <ModalQuickViewClient {...props} quickViewProps={quickViewProps} setQuickViewProps={setQuickViewProps} />
      <ModalAddClient {...props} {...addModalProps} setAddModalProps={setAddModalProps} />
    </main>
  );
}

export default Clients;
